<template>
  <div>
    <form v-on:submit.prevent="onSubmit">
      <v-toolbar class="primary elevation-0 small-extension" dark>
        <h1 class="titulo">Usuários</h1>
      </v-toolbar>
      <v-layout row wrap align-center class="secondary white--text detalhes-header">
        <v-flex xs2>
          <v-container fluid class="py-2">      
            <v-layout row wrap>
              <v-flex xs12 class="text-xs-center">
                <v-btn icon :to="({ name: 'UsuariosLista' })" class="ma-0 white--text">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs8>
          <v-container fluid class="py-2">      
            <v-layout row wrap>
              <v-flex xs12>
                <span class="subtitulo">Adicionar usuário</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs2>
          <v-container fluid class="py-2">
            <v-layout row wrap>
              <v-flex xs12>
                <v-btn flat @click.stop="onSubmit" :disabled="isFormInvalid">
                  <span class="subtitulo">Salvar</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="pt-5">
        <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
          <v-container fluid>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 class="text-xs-center">
                <img :src="imageSrc" class="avatar" style="border-color: #F37021; width: 150px; height: 150px; display: inline-block;">
                <label class="subheading secondary--text mt-2 mb-4" style="text-transform: uppercase; width: 100%; float: left; cursor: pointer;">
                  Adicionar foto
                  <input type="file" accept="image/*" ref="fileInput" @change="onFileChange" style="display: none;">
                </label>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  v-model="form.fields.name"
                  label="Nome"
                  v-validate="'required'"
                  name="name"
                  data-vv-as="nome"
                  :error-messages="errors.has('name') ? errors.first('name') : []"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.fields.cargo"
                  label="Cargo"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.fields.celular"
                  label="Celular"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 class="my-2">
                <strong>Login</strong><br>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  v-model="form.fields.email"
                  label="E-mail"
                  v-validate="'required|email'"
                  name="email"
                  data-vv-as="email"
                  :error-messages="errors.has('email') ? errors.first('email') : []"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  type="password"
                  v-model="form.fields.password"
                  label="Senha"
                  v-validate="'required|min:6'"
                  name="password"
                  data-vv-as="senha"
                  :error-messages="errors.has('password') ? errors.first('password') : []"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  type="password"
                  v-model="form.fields.conf_password"
                  label="Confirmar senha"
                  v-validate="'min:6|confirmed:password'"
                  name="conf_password"
                  data-vv-as="confirmação de senha"
                  :error-messages="errors.has('conf_password') ? errors.first('conf_password') : []"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-bind:items="customRoles"
                  item-text="name"
                  item-value="id"
                  v-model="form.fields.custom_role_id"
                  label="Nível de acesso"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex xs12 class="switch-fix">
                <strong>Usuário <span v-if="form.fields.bloqueado">bloqueado</span><span v-else>desbloqueado</span></strong>
                <v-switch
                  v-model="form.fields.bloqueado" 
                  color="secondary"
                  hide-details
                >
                </v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </form>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'
  import ImageTools from '@/components/Utils/resizeBeforeUpload'

  export default {
    data () {
      return {
        imageSrc: 'static/default.jpg',
        customRoles: [],
        form: {
          fields: {
            avatar: null,
            name: '',
            cargo: '',
            celular: '',
            email: '',
            password: '',
            conf_password: '',
            custom_role_id: null,
            bloqueado: false
          }
        }
      }
    },
    mounted () {
      this.loadCustomRoles()
    },
    computed: {
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      }
    },
    methods: {
      loadCustomRoles () {
        axios.get(`${apiURL}/roles`).then((response) => {
          this.customRoles = response.data.data
        })
      },
      onFileChange (event) {
        const input = event.target

        if (input.files && input.files[0]) {
          const reader = new FileReader()

          reader.onload = (e) => {
            this.imageSrc = e.target.result
          }

          reader.readAsDataURL(input.files[0])
          this.form.fields.avatar = input.files[0]
        }
      },
      onSubmit () {
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll().then((result) => {
          if (result) {
            const formData = new FormData()

            Object.keys(this.form.fields).forEach((key) => {
              if (key !== 'avatar' && this.form.fields[key] !== null) {
                formData.append(key, this.form.fields[key])
              }
            })

            if (this.form.fields.avatar !== null) {
              ImageTools.resize(this.form.fields['avatar'], {
                width: 300,
                height: 300
              }, (blob, didItResize) => {
                formData.append('avatar', blob)

                axios.post(`${apiURL}/usuarios`, formData).then((response) => {
                  this.$store.dispatch('utils/showSnackbar', {
                    persistent: true,
                    type: 'success',
                    text: `O usuário ${response.data.data.name} foi criado com sucesso!`
                  })
                  this.$store.dispatch('utils/hideLoading')
                  this.$router.push({ name: 'UsuariosLista' })
                }, (error) => {
                  let errorText = ''
                  if (error.response.status === 422) {
                    errorText = 'E-mail já cadastrado. Por favor, escolha outro.'
                  } else {
                    errorText = 'Servidor indisponível. Tente novamente mais tarde.'
                  }
                  this.$store.dispatch('utils/showSnackbar', {
                    text: errorText
                  })
                  this.$store.dispatch('utils/hideLoading')
                })
              })
            } else {
              axios.post(`${apiURL}/usuarios`, formData).then((response) => {
                this.$store.dispatch('utils/showSnackbar', {
                  persistent: true,
                  type: 'success',
                  text: `O usuário ${response.data.data.name} foi criado com sucesso!`
                })
                this.$store.dispatch('utils/hideLoading')
                this.$router.push({ name: 'UsuariosLista' })
              }, (error) => {
                let errorText = ''
                if (error.response.status === 422) {
                  errorText = 'E-mail já cadastrado. Por favor, escolha outro.'
                } else {
                  errorText = 'Servidor indisponível. Tente novamente mais tarde.'
                }
                this.$store.dispatch('utils/showSnackbar', {
                  text: errorText
                })
                this.$store.dispatch('utils/hideLoading')
              })
            }
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UsuariosAdicionar.vue?5d5bcf24